module.exports = __webpack_public_path__ + "img/menu.5cab5c52.svg";